import { useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchMultipleRoles } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const RolesDropdownMultiSelector = ({
  errors,
  control,
  setValue,
  watch,
  mappedData,
}) => {
  const selectedRoles = watch("role_id");

  const {
    data: Roles,
    isLoading,
    error,
  } = useQuery(["RolesDropdown"], () => fetchMultipleRoles(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const optionsList = useMemo(
    () =>
      Roles?.data?.data?.map((data) => ({
        value: data.role_id,
        label: data.role_name,
      })) || [],
    [Roles, mappedData]
  );
  const options = mappedData
    ? optionsList.filter((ele) => !mappedData.includes(ele.label))
    : optionsList;

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading observations</div>;

  return (
    <Controller
      name="role_id"
      control={control}
      rules={{ required: "roles is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          isMulti
          placeholder="Select Roles"
          menuPortalTarget={document.body}
          value={options.filter((option) =>
            selectedRoles?.includes(option.value)
          )}
          onChange={(selectedOptions) => {
            const values = selectedOptions
              ? selectedOptions.map((option) => option.value)
              : [];
            const labels = selectedOptions
              ? selectedOptions.map((option) => option.label)
              : [];
            field.onChange(values);
            setValue("role_id", values);
            setValue("role_name", labels);
          }}
          className={`react-select-container ${
            errors.role_id ? "is-invalid" : ""
          }`}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              minHeight: "42px",
              maxHeight: "auto",
              overflowY: "auto",
            }),
            valueContainer: (base) => ({
              ...base,
              maxHeight: "42px",
              overflowY: "auto",
            }),
            multiValue: (base) => ({
              ...base,
              maxWidth: "100%",
            }),
          }}
        />
      )}
    />
  );
};

export default RolesDropdownMultiSelector;
